import React from "react";
import {Bar} from "react-chartjs-2";

export default function HorizontalBarChart({ chartData, aspectRatio }) {
  return (
    <>
      <Bar
        data={chartData}
        options={{
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 2,
            }
          },
          responsive: true,
          aspectRatio: aspectRatio ?? 2,
          plugins: {
            legend: {
              display: true
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (context.dataset.data) {
                    label += ` ${new Intl.NumberFormat('sr-RS', {
                      style: 'currency',
                      currency: 'RSD'
                    }).format(context.dataset.data[context.dataIndex] ?? 0)}`;
                  }
                  return label;
                }
              }
            }
          }
        }}
      />
    </>
  );
}
